import React, { Component } from "react";
import '../InitialForm/InitialFormStyleSheet.css';
import Select from 'react-select';
import { s360ConfigService } from "../Services/S360Config";

class Dropdown extends Component {

    constructor(props) {
        super(props);
        this.messageRef = React.createRef();
    }

    render() {
        let optionsArray = []
        this.props && this.props.item.options && this.props.item.options.map(eachOption => { optionsArray.push({ value: eachOption, label: eachOption }) })
        return (
            <div className="s360-initial-form-textbox-container" style={this.formInputBoxContainerStyle()} >
                {/* <fieldset style={{"border":"1px solid silver","margin":"6px -1px","padding":"0 .625em 0","borderRadius":"5px"}}> */}
                <fieldset style={{"border-bottom":"1px solid silver","margin":"6px -1px","marginTop":"0px"}}>
                    <legend  id={'lbl'+this.props.idxx}  style={{"width":"auto","padding":"2px","marginBottom":"-3px","fontSize":"10px","lineHeight":"inherit","color":"rgb(108, 103, 103)","border":"0","borderBottom":"none","display":"none","fontFamily":"poppins"}}>{this.props.item.label}</legend>
                    <Select  styles={this.selectOptionsStyle } maxMenuHeight={198}  menuPortalTarget={document.body}  options={optionsArray}  captureMenuScroll={false} isSearchable={false} onChange={e => this.onSelectOption('lbl'+this.props.idxx,e)}  components={{
                    IndicatorSeparator: () => null}} placeholder={this.props.item.label}/>  
                    </fieldset>
            </div>
        );
    }

   handleKeyPress = (selectedOption) =>{
    this.selectedOption = selectedOption.value;
   }

    selectedOption = null;
    onSelectOption = (idx,selectedOption) => {
        console.log("this.selectedoption",this.selectOption,"selectedOption",selectedOption)
        this.selectedOption = selectedOption.value;
        document.getElementById(idx).style.display = "block";
    }

    formInputBoxContainerStyle = () => {
        return {
            color: s360ConfigService.config.designDetails.headerColor,
        }
    }

    formInputBoxStyle = () => {
        return {
            borderColor: s360ConfigService.config.designDetails.headerColor,
            backgroundColor: s360ConfigService.config.designDetails.pageBackgroundColor

        }
    }

    value = () => {
        if (!this.selectedOption) { return {} ; }
        let aValue = {};
        aValue[this.props.item.label] = this.selectedOption; 
        return aValue;
    };

    validate = () => { 
        let formItemDetails = this.props.item || {};
        let isRequired = formItemDetails.required || formItemDetails.primaryField;
        return !(isRequired && !this.selectedOption);
    }

    validationErrorMessage = () => {
        return "Please select " + this.props.item.label.toLowerCase() + ".";
    }

    // DropdownIndicator = () => {
    //     return (<img style={{ color: "#1F175C" }} src={dropDownImage} className="dropdownIndicator" alt="/"></img>)
    // }

    

    selectOptionsStyle = {
        control: (provided, state) => ({
            ...provided,
            // border: '2px solid' + s360ConfigService.config.designDetails.headerColor,
             boxShadow: 'none',
            // borderRadius: '0px',
            borderStyle: 'unset',
            paddingBottom: "0px",
             color: s360ConfigService.config.designDetails.headerColor,
            width: '100% !important',
            overflowY:'visible !important'
            // // height: 35,
            // minHeight: 34,
            // border: state.isFocused ? '1px solid ' : '1px solid '+ s360ConfigService.config.designDetails.headerColor,
            // This line disable the blue border
            // boxShadow: state.isFocused ? '1px solid ' + s360ConfigService.config.designDetails.headerColor : '1px solid ' + s360ConfigService.config.designDetails.headerColor,
            // '&:hover': {
            //     border: state.isFocused ? '1px solid ' + s360ConfigService.config.designDetails.headerColor : '1px solid ' + s360ConfigService.config.designDetails.headerColor
            // }
        }),
        singleValue: (provided, state) => ({
            ...provided,
            // width: "68%",
            color: s360ConfigService.config.designDetails.headerColor,
            fontSize: "13px",
            fontWeight: "bold",
            fontFamily: "lato"
        }),
        valueContainer: (provided, state) => ({
             ...provided, 
             overflow: 'hidden',
            //  boxSizing: border-box,
             
              paddingLeft:  "0px",
            //  paddingBottom: "14px",
            }),
        menuPortal: base => ({ ...base, zIndex: 9999 }),
        menuList: base => ({
            ...base,
            paddingBottom:"0px"
        }),

        indicatorsContainer: (provided, state) => ({ 
            ...provided,
            "svg": {
                fill: "#1F175C",
                paddingBottom: "1px",
              }
            }),

            menu: (provided, state) => ({
                ...provided,
                zIndex:9999,
                overflowY: 'visible !important',
                fontFamily:"poppins"
              }),
            

            placeholder: (provided, state) => ({ 
                ...provided, 
                 color: '#AAAAAA', 
                 fontSize: '12px', 
                 fontFamily:'lato',
                 fontWeight:'500'
                }),        

        option: (styles, { data, isDisabled, isFocused, isSelected }) => {
            const color = s360ConfigService.config.designDetails.formButtonBackground;
            return {
                ...styles,
                backgroundColor: isDisabled
                    ? null
                    : isSelected
                        ? color
                         : isFocused
                             ? "rgb(31 23 92 / 13%)"
                            : null,
                ':active': {
                    ...styles[':active'],
                    backgroundColor: null,
                },
                borderBottom: '1px solid #ccc',
            };
        },
    };


}


export default Dropdown;